import * as React from 'react';

const ScreenMediumSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M6 20h12v-3H6v3zm0-4h12V4H6v12zM5 3v18h14V3H5z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M11 18h2v1h-2z"
        />
    </svg>
);

ScreenMediumSvg.displayName = 'ScreenMediumSvg';
export default ScreenMediumSvg;
